// FILE: src/components/Legal/ModalPrivacy.js
import React, { lazy, Suspense } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Button,
    Box,
    useMediaQuery,
    Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";

// ⬇️ Adjust import path if needed based on your structure
const PrivacyPolicy = lazy(() => import("./TermsOfUse"));

export default function ModalTOS({ open, onClose }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            fullScreen={fullScreen}
            PaperProps={{
                sx: {
                    borderRadius: fullScreen ? 0 : 3,
                    overflow: "hidden",
                },
            }}
        >
            <DialogTitle
                sx={{
                    pr: 7,
                    fontWeight: 800,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                Terms of Services
                <IconButton
                    onClick={onClose}
                    aria-label="Close"
                    sx={{ position: "absolute", right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <Divider />

            <DialogContent
                dividers
                sx={{
                    p: 0, // Let embedded page handle its own padding
                    backgroundColor: theme.palette.background.default,
                }}
            >
                {/* Scroll container so long policies don’t stretch the dialog */}
                <Box sx={{ maxHeight: fullScreen ? "90vh" : "70vh", overflow: "auto" }}>
                    <Suspense fallback={<Box sx={{ p: 3 }}>Loading…</Box>}>
                        {/* embed=true hides Header/Footer/DateBar inside the modal */}
                        <PrivacyPolicy embed />
                    </Suspense>
                </Box>
            </DialogContent>

            <DialogActions sx={{ px: 2, py: 1.5 }}>
                <Button
                    onClick={onClose}
                    variant="outlined"
                >
                    Close
                </Button>
                <Button
                    href="/privacy-policy"
                    target="_blank"
                    rel="noreferrer"
                    endIcon={<OpenInNewRoundedIcon />}
                >
                    Open in new tab
                </Button>
            </DialogActions>
        </Dialog>
    );
}
